import React from "react"
import { Avatar } from "material-ui"
import LogoPlaceholder from "material-ui/svg-icons/device/wallpaper"
import EditIcon from "material-ui/svg-icons/image/edit"
import RemoveIcon from "material-ui/svg-icons/action/delete"
import AppStateStore from "../../../stores/AppStateStore"
import autobind from "class-autobind"
import * as utils from "../../../helpers/utils"
import strings from "../../../localization/strings"
interface IProps {
	readonly: boolean
	pictureUrl: string
	selectContactPicture(imageData: string | boolean): void
}
interface IState {
	picture: string
}

export default class SelectProfilePicture extends React.Component<IProps, IState>  {
	fileUploader: HTMLInputElement
	constructor(props) {
		super(props)
		this.state = {
			picture: props.pictureUrl
		}
		autobind(this)
	}

	async handleFileChange(e) {
		if (!utils.validateImgFileExtension(e.target.files[0])) {
			AppStateStore.setAlertDialogContent({
				title: strings.This_file_format_is_not_supported,
				content: strings.Supported_file_types + ": .png, .jpg, .jpeg"
			})
		} else if (!utils.validateFileSize(e.target.files[0])) {
			AppStateStore.setAlertDialogContent({
				title: strings.This_file_size_is_too_large,
				content: strings.Maximum_File_Size + ": 10 MB"
			})
		} else {
			const imageData = await utils.getBase64(e.target.files[0])
			this.setState({ picture: imageData as string }, () => this.props.selectContactPicture(`${imageData}`))
		}
	}

	handleRemovePicture() {
		this.setState({ picture: "" }, () => this.props.selectContactPicture(false)) // Setting Picture false as a signal to remove
		this.fileUploader.value = null
	}

	render() {
		return (
			<div style={{ width: 300 }}>
				<div><label>{strings.Profile_Picture}</label></div>
				<Avatar
					style={{ width: 75, height: 75, }}
					icon={this.state.picture === "" ? <LogoPlaceholder /> : null}
					src={this.state.picture !== "" ? this.state.picture : ""}
				/>
				{!this.props.readonly && [
					<span title={strings.Select_Profile_Picture} key="upload">
						<EditIcon						
							style={{ color: "#95989a", cursor: "pointer", marginBottom: -29 }}
							onTouchTap={() => this.fileUploader.click()}
						/>
					</span>,
					this.state.picture !== null && this.state.picture !== "" &&
					<span title={strings.Unselect_Profile_Picture} key="remove">
						<RemoveIcon
							style={{ color: "#95989a", cursor: "pointer", marginLeft: -22 }}
							onTouchTap={() => this.handleRemovePicture()}
						/>
					</span>
				]}
				<input type="file" id="file" onChange={this.handleFileChange} ref={(ref) => this.fileUploader = ref} style={{ display: "none" }} />
			</div>
		)
	}
}